import { BillingInterval, MembershipType, PlanType } from "./types";

const url = "/api/v1/current_user";

// ref: https://stripe.com/docs/billing/subscriptions/overview#subscription-statuses
type SubscriptionStatus =
  | "active"
  | "trialing"
  | "canceled"
  | "incomplete"
  | "incomplete_expired"
  | "past_due"
  | "paused" // custom from our end
  | "unpaid";

export type IAlert =
  | "onboarding"
  | "refer-a-friend"
  | "trial-one-week-left"
  | "trial-three-weeks-left";

export interface CurrentUser {
  alerts: IAlert[];
  avatarNumber: 0 | 1 | 2 | 3 | 4;
  externalId: string;
  cohort: {
    cohortWhatsAppLink: string;
    id: string | null;
    nextMeetingAt: string | null;
    notionLink: string;
    startAt: string | null;
    zoomLink: string;
  };
  email: string;
  firstName: string;
  hasCohortEnded: boolean;
  isAdmin: boolean;
  isCoach: boolean;
  isLegacy: boolean;
  isOnboarded: boolean;
  isEditor: boolean;
  isEligibleForReferral: boolean;
  isPasswordSet: boolean;
  isPaying: boolean;
  lastName: string;
  membership: {
    type: MembershipType;
  };
  partner: {
    activatedAt: string | null;
    coupon: {
      amount: number | null;
      type: "percent" | "amount" | null;
      expires: string | null;
    };
    endedAt: string | null;
    extendedAt: string | null;
    name: string | null;
    slug: string | null;
    upcomingPlan: PlanType | null;
  };
  profilePicture: string | undefined;
  referralToken: string;
  subscription: {
    billingInterval: BillingInterval;
    canceledAt: string | null;
    currentPeriodEnd: string | null;
    hasUpcomingDiscount: boolean | null;
    plan: PlanType | null;
    pause: {
      endedAt: string | null;
      hasUpcomingPause: boolean | null;
      isEligible: boolean | null;
      startedAt: string | null;
    };
    status: SubscriptionStatus | null;
    scheduledBillingInterval: BillingInterval | null;
  };
  ui: {
    hasClosedOnboardingMessage: boolean;
    hasClosedReferralMessage: boolean;
    hasClosedTrialOneWeekLeft: boolean;
    hasClosedTrialThreeWeeksLeft: boolean;
  };
}

interface UserSerializer {
  data: {
    attributes: CurrentUser;
  };
}

export type CurrentUserIndexResponse = UserSerializer;

export const currentUserIndexQuery = () => url;

export type CurrentUserUpdateResponse = UserSerializer;

export interface CurrentUserUpdateParams {
  firstName?: string;
  lastName?: string;
  plan?: PlanType | null;
  billingInterval?: BillingInterval;
}

export const currentUserUpdateQuery = (params: CurrentUserUpdateParams) => ({
  url,
  method: "PATCH",
  body: params,
});
